import Api from "./Api";

const blogServices = {
  getAllBlogs(params) {
    return Api().get(`/website/blogs/all`, { params });
  },

  getBlogBySlug(slug) {
    return Api().get(`/website/blogs/slug/${slug}`);
  },

  getBlogById(blogId) {
    return Api().get(`/website/blogs/single/${blogId}`);
  },
};

export default blogServices;
